import { Button, CircularProgress, styled } from "@mui/material";
import React from "react";

const StyledButton = styled(Button)`
  :disabled {
    color: #fff;
    background: #000;
    cursor: none;
  }
  background: #1a1998;
`;

function CustomButton({ onClick, children, type = "", disabled, isLoading= false }) {
  return (
    <StyledButton
      variant="contained"
      size="large"
      onClick={onClick}
      type={type}
      style={{}}
      disabled={disabled}
    >
      {isLoading ? <CircularProgress size={25} color="inherit" /> : children}
    </StyledButton>
  );
}

export default CustomButton;
